'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.replaceSpecialCharacters = replaceSpecialCharacters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Replaces the given map in the string.
 * @param string
 * @param specialCharacters
 */
function replaceSpecialCharacters(string, specialCharacters) {
    var regexp = new RegExp('[' + (0, _keys2.default)(specialCharacters).join('') + ']', 'g');
    return string.replace(regexp, function (character) {
        return specialCharacters[character];
    });
}